module.exports = "/_next/static/images/thumbs_up-68fd94e361dad16e4deb7cd6c2750704.png";